// File names of the list pictures (public/demos/thumbs/<name>.webp): the clip, plus the equipment shown when there is one.
import type { DemoHold, DemoPropKind } from '@fitness/core';

export interface ThumbSpec {
  name: string;
  clip: string;
  kind: DemoPropKind | null;
  hold: DemoHold | null;
  oneArm: boolean;
  down: boolean;
}

export function thumbName(s: Omit<ThumbSpec, 'name'>): string {
  return s.kind && s.hold ? `${s.clip}--${s.kind}-${s.hold}${s.oneArm ? '-one' : ''}${s.down ? '-down' : ''}` : s.clip;
}

/** The parts of a picture name again (for the renderer). */
export function parseThumbName(name: string): ThumbSpec {
  const [clip, rest] = name.split('--') as [string, string | undefined];
  if (!rest) return { name, clip, kind: null, hold: null, oneArm: false, down: false };
  const [kind, hold, ...flags] = rest.split('-');
  return { name, clip, kind: kind as DemoPropKind, hold: hold as DemoHold, oneArm: flags.includes('one'), down: flags.includes('down') };
}

/** Small pictures for list rows (about 3x a 56 px row, square), next to the large ones for cards. */
export const smallThumb = (url: string) => url.replace(/\.webp$/, '.sm.webp');
